import { RequestCapability } from '../../core/request-capability.js';
import { requestExtension } from '../../core/request-modification.js';
/**
 * @internal
 */
class RenderingCapability extends RequestCapability {
    for(handler) {
        return ({ request: { method }, response, next }) => {
            const renderBody = (body, encoding = 'utf-8') => {
                const length = Buffer.isBuffer(body) ? body.byteLength : Buffer.byteLength(body, encoding);
                response.setHeader('Content-Length', length);
                if (method === 'HEAD') {
                    response.end();
                }
                else {
                    response.end(body, encoding);
                }
            };
            return next(handler, requestExtension({
                renderBody,
                renderHtml(html) {
                    response.setHeader('Content-Type', `text/html; charset=utf-8`);
                    renderBody(html);
                },
                renderJson(body) {
                    response.setHeader('Content-Type', `application/json; charset=utf-8`);
                    renderBody(JSON.stringify(body));
                },
            }));
        };
    }
}
/**
 * HTTP response rendering capability.
 *
 * Provides {@link RenderMeans HTTP response body render means} for handlers.
 */
export const Rendering = 
/*#__PURE__*/ new RenderingCapability();
//# sourceMappingURL=rendering.capability.js.map